import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

const STATUS = [
  { key: 'EM ELABORAÇÃO', label: 'Em Elaboração', color: '#0d6efd' },
  { key: 'ENVIADO PARA APROVAÇÃO', label: 'Enviado p/ Aprovação', color: '#6f42c1' },
  { key: 'DEVOLVIDO PARA AJUSTES', label: 'Devolvido p/ Ajustes', color: '#e0a800' },
  { key: 'APROVADO', label: 'Aprovado', color: '#28a745' },
  { key: 'REPROVADO', label: 'Reprovado', color: '#dc3545' },
];

const TramitacaoChart = ({ data }) => {
  const activeStatuses = STATUS.filter(s => (data[s.key] || 0) > 0);
  const isEmpty = activeStatuses.length === 0;

  const finalLabels = isEmpty ? ['Sem dados'] : activeStatuses.map(s => s.label);
  const finalValues = isEmpty ? [1] : activeStatuses.map(s => data[s.key] || 0);
  const colors = isEmpty ? ['#ced4da'] : activeStatuses.map(s => s.color);

  const barLabelsPlugin = {
    id: 'barLabels',
    afterDatasetsDraw(chart) {
      const { ctx } = chart;
      const meta = chart.getDatasetMeta(0);
      const ds = chart.data.datasets[0];
      if (!meta.data.length) return;
      ctx.save();
      ctx.font = '600 11px "Segoe UI", sans-serif';
      ctx.fillStyle = '#495057';
      ctx.textBaseline = 'middle';
      ctx.textAlign = 'left';
      meta.data.forEach((bar, i) => {
        const value = ds.data[i];
        if (value === 0) return;
        ctx.fillText(String(value), bar.x + 8, bar.y);
      });
      ctx.restore();
    },
  };

  const chartData = {
    labels: finalLabels,
    datasets: [
      {
        data: finalValues,
        backgroundColor: colors,
        borderRadius: 4,
        borderSkipped: false,
        barPercentage: 1,
        categoryPercentage: 0.9,
        maxBarThickness: 26,
      },
    ],
  };

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
        borderColor: '#fff',
        borderWidth: 1,
        callbacks: {
          label: (context) => {
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const pct = total > 0 ? ((context.parsed.x / total) * 100).toFixed(1) : 0;
            return `${context.parsed.x} (${pct}%)`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        border: { display: false },
        ticks: { display: false },
      },
      y: {
        grid: { display: false },
        border: { display: false },
        ticks: {
          font: { size: 11 },
          color: '#495057',
          crossAlign: 'far',
          autoSkip: false,
        },
      },
    },
    layout: { padding: { top: 4, right: 30 } },
    animation: { duration: 800 },
  };

  return (
    <div className="d-flex flex-column h-100">
      <h5 className="text-center text-dark mb-2">DFD POR TRAMITAÇÃO</h5>
      <div className="flex-grow-1">
        <Bar data={chartData} options={options} plugins={[barLabelsPlugin]} />
      </div>
    </div>
  );
};

export default TramitacaoChart;
